import styled from 'styled-components/macro';
import Select from 'react-select';
import chevron from 'assets/icons/chevron.svg';

export const TypeSelect = styled(Select)`
  min-width: 91px;
`;

export const CustomTypeStyles = {
  dropdownIndicator: (base: any) => ({
    ...base,
    display: 'none',
  }),
  option: (base: any, state: any) => ({
    ...base,
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
    padding: '8px 12px',
    backgroundColor: state.isFocused ? '#F2F5F8' : '#FFFFFF',
    color: '#1F2939',
    '&:active': {
      backgroundColor: '#F2F5F8',
    },
  }),
  menuList: (base: any) => ({
    ...base,
    borderRadius: '8px',
    padding: '4px 0',
    boxShadow:
      '0px 2px 4px 0px rgba(15, 23, 40, 0.04), 0px 4px 8px 0px rgba(15, 23, 40, 0.12), 0px 0px 10px 6px rgba(15, 23, 40, 0.04)',
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '12px 0 12px 12px',
    width: '70px',
  }),
  singleValue: (base: any) => ({
    ...base,
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
    textAlign: 'left',
    textOverflow: 'none',
    color: '#1f2939',
    margin: '0',
    cursor: 'default',
  }),
  indicatorSeparator: (state: any) => ({
    ...state,
    display: 'none',
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
};

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  height: 37px;
  box-shadow: none;
  border-radius: 8px 0 0 8px;
  border: none;
`;

export const ChevronIcon = styled.img.attrs({
  src: chevron,
})<{ isOpen: boolean }>`
  box-sizing: content-box !important;
  padding: ${(props) => (props.isOpen ? '8px 0 8px 8px' : '8px 8px 8px 0')};
  rotate: ${(props) => (props.isOpen ? '180deg' : '0')};
  height: 16px;
  width: 16px;
  cursor: pointer;
`;

export const FixedType = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 67px;
  font-size: 14px;
  padding: 12px 0px 12px 12px;
`;
